import { render, staticRenderFns } from "./detectionDetail.vue?vue&type=template&id=9c1f5a28&scoped=true"
import script from "./detectionDetail.vue?vue&type=script&lang=js"
export * from "./detectionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c1f5a28",
  null
  
)

export default component.exports